<template>
  <Modal v-model="openFlowForm" title="发起流程" footer-hide width="400" height="400" :mask-closable="false"
    :closable="false">
    <Form ref="flowItem" :model="flowItem" :rules="ruleValidate" :label-width="80">
      <Row :gutter="16">
        <Col span="24">
        <FormItem label="表单编号" prop="title">
          <Input v-model="flowItem.title" readonly></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem label="流程名称" prop="flowId">
          <Select @on-select="selectFlow" v-model="flowItem.flowId" style="width: 100%">
            <Option :value="x.id" v-for="(x, index) in flowList" :key="index" :label="x.name">
              <span>{{ x.name }}</span>
            </Option>
          </Select>
        </FormItem>
        </Col>
        <Col span="24" v-if="false">
        <FormItem label="备注内容" prop="content">
          <Input v-model="flowItem.content" placeholder="请输入"></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem label="下个节点" prop="nextNodeName">
          <Input v-model="flowItem.nextNodeName" readonly></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem label="待办人" prop="auditorUser1">
          <Select :filterable="true" v-model="flowItem.auditorUser1" @on-change="selectUser" :multiple="true">
            <Option v-for="(x, index) in users" :key="index" :label="x.name" :value="x.accountId"></Option>
          </Select>
        </FormItem>
        </Col>
        <Col span="24" v-show="false">
        <FormItem label="图片" prop="beforeImgList">
          <ly-photo ref="lyphoto" v-model="flowItem.beforeImgList"></ly-photo>
        </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="end">
        <Col span="24">
        <div class="btn-wrap">
          <!-- <Button @click="noCreated"
              >不发流程</Button
            > -->
          <Button type="primary" @click="createdFlow('flowItem')">发起流程</Button>
        </div>
        </Col>
      </Row>
    </Form>
  </Modal>
</template>
<script>
export default {
  data() {
    return {
      openFlowForm: false,
      flowItem: {
        groupId: "",
        flowId: "",
        title: "",
        docId: "",
        formId: "",
        auditorUserid: [],
        auditorUser: [],
        content: "流程发起",
        beforeImg: "",
        beforeImgList: [],
        afterImg: "",
        filePath: "",
        nextNodeName: "", //前端看的，不需要传后台
      },
      flowList: [],
      ruleValidate: {
        title: { required: true, message: "必填" },
        flowId: { required: true, message: "必填" },
        content: { required: true, message: "必填" },
        auditorUser1: { required: true, message: "必填" },
      },
      users: []
    };
  },
  methods: {
    reach(v) {
      
      this.openFlowForm = true;
      this.flowItem.title = v.no;
      this.flowItem.docId = v.id;
      this.flowItem.groupId = v.groupId;
      this.flowItem.flowId = v.flowId;
      this.flowItem.formId = v.formId;
      this.filler = v.filler;
      this.getFlowList();

      //this.getNextNode({value:v.flowId});
    },
    //创建流程

    createdFlow(name) {
      this.flowItem.beforeImg = this.flowItem.beforeImgList.join(",");
      console.log(this.flowItem);
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.axios({
            method: "post",
            url: this.axios.flow + "/flow/newFlowProcess",
            data: this.flowItem,
          }).then((res) => {
            this.$Spin.hide(); //关闭加载
            if (res) {
              this.openFlowForm = false;
              this.$emit("ok", true);
            }
          });
        }
      });
    },
    getFlowList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.flow + "/flowConfig/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data=res.data.data.dataList;
        var arr = [];
        for (let i = 0; i < data.length; i++) {

          if (data[i].serverUrl.indexOf(this.filler) != -1) {
            arr.push(data[i]);
          }
        }
        console.log('liucheng', data);
        this.flowList = arr;
        if (this.flowList.length == 1) {
          this.getNextNode(data[0])
        }
      });
    },
    getNextNode(row) {
      ///cloud-common-server-flow/flow/nextNode
      this.utils.loading(this, "加载中");
      var can = {
        flowId: row.id,
        nodeId: "T001",
        nodeType: 1, //0-开始节点(新建时指定),1-中间节点,2-结束节点
      };
      this.axios({
        method: "post",
        url: this.axios.flow + "/flow/nextNode",
        data: can,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        var data = res.data.data;

        this.flowItem.nextNodeName = data.name;
        this.flowItem.auditorUserid = [];
        this.flowItem.auditorUser = [];
        var rule123 = data.rule;
        var mmm = this.flowItem;
        if (rule123 == "banzuzhang" && rule[rule123].autoSelectUser) {
          var obj = {
            accountId: mmm.workerId,
            name: mmm.workerLeader,
          };
          this.users = [obj];
          this.flowItem.auditorUserid = [mmm.workerId];
          this.flowItem.auditorUser = [mmm.workerLeader];
        } else {
          this.users = data.user;

        }
        //this.flowItem.auditorUser1 = this.flowItem.auditorUserid[0];
      });
    },
    selectUser(x) {
      // console.log(this.flowItem.auditorUser1, this.users);
      var users = this.users, t = this.flowItem.auditorUser1;

      var a = [], b = [];
      for (let i = 0; i < users.length; i++) {
        for (let j = 0; j < t.length; j++) {
          if (users[i].accountId == t[j]) {
            a.push(users[i].accountId);
            b.push(users[i].name);
          }
        }
      }
      this.flowItem.auditorUserid = a;
      this.flowItem.auditorUser = b;
      console.log(a, b);
    },
    selectFlow(v) {
      v.id = v.value;
      this.getNextNode(v);
    },
    noCreated() {
      this.$Modal.confirm({
        title: "确定不走流程",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.openFlowForm = false;
        },
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/diaodu/forms/createdFlow.vue